import { render } from "./DebtorFieldConfigView.vue?vue&type=template&id=289c4c3c&scoped=true"
import script from "./DebtorFieldConfigView.vue?vue&type=script&lang=js"
export * from "./DebtorFieldConfigView.vue?vue&type=script&lang=js"

import "./DebtorFieldConfigView.vue?vue&type=style&index=0&id=289c4c3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289c4c3c"]])

export default __exports__